import React from 'react';
import { ClassAssembly9B2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly9B2026/>;
  };
  
  export default ClassAssemblyPage;